import { createContext, useState, ReactNode, useEffect, useRef } from 'react';
import { AlertContextValue, Alert, ShowShowFn, SoftAlertType } from './types';
import { AlertContainer } from './AlertContainer';
import { setTimeoutAlertHandler } from '@/features/alerts/timeoutInterceptor';

export const AlertContext = createContext<AlertContextValue | null>(null);

interface Props {
  children: ReactNode;
}

export function AlertProvider({ children }: Props) {
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const idCounter = useRef(0);

  const showAlert: ShowShowFn = (message, type = SoftAlertType.error, duration = 10000, systemType) => {
    // Check if system message of this type already exists and remove it
    if (systemType) {
      setAlerts(prev => prev.filter(alert => alert.systemType !== systemType));
    }
    const id = ++idCounter.current;

    setAlerts(prev => [...prev, { id, message, type, duration, systemType }]);

    return id;
  };

  const hideAlert = (id: number) => {
    setAlerts(prev => prev.filter(n => n.id !== id));
  };

  // Wire up timeout interceptor
  useEffect(() => {
    setTimeoutAlertHandler(showAlert);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert: showAlert, hideAlert: hideAlert }}>
      {children}
      <AlertContainer alerts={alerts} onHideAlert={hideAlert} />
    </AlertContext.Provider>
  );
}
